import { useState, useEffect, useMemo } from 'react';

export const useAliasFilters = (aliases) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredAliases, setFilteredAliases] = useState([]);

  // Extract unique field keys from aliases
  const fieldKeys = useMemo(() => {
    const keys = new Set(aliases.map(alias => alias.fieldKey));
    return Array.from(keys).sort();
  }, [aliases]);

  // Apply filters whenever aliases or search term changes
  useEffect(() => {
    applyFilters();
  }, [aliases, searchTerm]);

  const applyFilters = () => {
    let filtered = [...aliases];

    // Apply search term filter
    if (searchTerm) {
      const lowerSearch = searchTerm.toLowerCase();
      filtered = filtered.filter(alias =>
        alias.originalValue.toLowerCase().includes(lowerSearch) ||
        alias.replacementValue.toLowerCase().includes(lowerSearch) ||
        alias.fieldKey.toLowerCase().includes(lowerSearch)
      );
    }

    setFilteredAliases(filtered);
  };

  return {
    filteredAliases,
    searchTerm,
    setSearchTerm,
    fieldKeys,
  };
};
